import moment from "moment";
import { AppointmentJoin } from "@/repositories/appointments.repository";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import AppointmentStatusBadge from "@/app/pmc/appointments/components/AppointmentStatusBadge";

interface UpcomingAppointmentsTableProps {
  appointments: AppointmentJoin[];
}

export default function UpcomingAppointmentsTable({ appointments }: UpcomingAppointmentsTableProps) {
  const formatDate = (dateString: string) => {
    return moment(dateString).format("MM/DD/YYYY");
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Upcoming Appointments</CardTitle>
        <CardDescription>Upcoming Bookings for next 10 days</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="rounded-md border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-[100px]">ID</TableHead>
                <TableHead>Property / Unit</TableHead>
                <TableHead>Service</TableHead>
                <TableHead>Scheduled Date</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Assigned To</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {appointments.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} className="h-24 text-center">
                    No upcoming appointments found.
                  </TableCell>
                </TableRow>
              ) : (
                appointments.map((appointment) => (
                  <TableRow key={appointment.id} className="text-xs">
                    <TableCell className="font-medium">#{appointment.id.slice(0, 8)}</TableCell>
                    <TableCell className="font-medium">
                      <div className="flex flex-col gap-1">
                        <span className="font-medium">{appointment.property.name}</span>
                        {appointment.property.unit_number && (
                          <span className="text-xs text-muted-foreground">
                            Unit {appointment.property.unit_number}
                          </span>
                        )}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="flex flex-col">
                        <span className="font-medium">{appointment.service.name}</span>
                        {appointment.final_price && (
                          <span className="text-xs text-muted-foreground">
                            ${appointment.final_price.toFixed(2)}
                          </span>
                        )}
                      </div>
                    </TableCell>
                    <TableCell>{formatDate(appointment.date)}</TableCell>
                    <TableCell>
                      <AppointmentStatusBadge status={appointment.status} />
                    </TableCell>
                    <TableCell>
                      {appointment.assigned_user?.name || (
                        <span className="text-muted-foreground">Unassigned</span>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
        {appointments.length > 0 && (
          <div className="flex items-center justify-between space-x-2 py-4">
            <div className="text-sm text-muted-foreground">
              Showing {appointments.length} appointment{appointments.length !== 1 ? "s" : ""}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
